import BookSuggestionService from "../../services/book-suggestion-service"
import { makeBookSuggestionResource } from "../resources/book-suggestion-resource-factory"

export const makeBookSuggestionService = (): BookSuggestionService => {
    return new BookSuggestionService(makeBookSuggestionResource())
}
